// extracted by mini-css-extract-plugin
module.exports = {"slido":"lower_slido__27yAJ","slideB":"lower_slideB__29-SZ","lower":"lower_lower__2ZGzG","lower_info":"lower_lower_info__3z7ak"};